export default "__VITE_ASSET__FSLGiS77__"